import { FC, ReactNode } from 'react'
import BaseNotification, { NotificationIcon } from './BaseNotification'
import warningIcon from '../../images/icons/warning.svg'

interface BaseWarningProps {
  onClose: () => void
  header?: string
  message: ReactNode
  hideCloseButton?: boolean
}

const warningIconData: NotificationIcon = {
  src: warningIcon,
  alt: 'Warning',
  imageStyle: {
    position: 'absolute',
    left: '10px',
    top: '10px',
    width: '20px',
    height: '20px',
  },
}

const BaseWarning: FC<BaseWarningProps> = ({
  onClose,
  header,
  message,
  hideCloseButton = false,
}) => {
  return (
    <BaseNotification
      onClose={onClose}
      header={header}
      message={message}
      icon={warningIconData}
      containerStyle={{ backgroundColor: '#fffae7' }}
      isHeaderInlineCloseButton={false}
      hideCloseButton={hideCloseButton}
    />
  )
}

export default BaseWarning
